import { Box, Container, Paper, Typography } from "@mui/material";
import React from "react";
import PageTitle from "../base/PageTitle";

const SmsTermsPage: React.FC = () => {
  return (
    <Box>
      <PageTitle title="SMS Terms & Conditions" />
      <Container sx={{ marginBottom: 8 }}>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="center"
          marginBottom={3}
        >
          <Typography variant="subtitle2">
            SecureVizual Pro is a service of Secure Vizual, LLC
          </Typography>
        </Box>
        <Paper
          sx={{
            paddingY: 3,
            paddingX: { xs: 2, md: 5 },
            marginBottom: 5,
          }}
        >
          <Box display="flex" flexDirection="column" gap={3}>
            <Typography>
              When you opt in to this service, we will send you security alerts
              and scheduled report notifications. Message frequency will depend
              on group membership, report scheduling, and alert activity. You
              can cancel the SMS or MMS service at any time by texting "STOP" to
              ####. When you send the SMS message "STOP" to us, we reply with an
              SMS message that confirms that you have been unsubscribed. After
              this, you will not receive any additional SMS messages from us. If
              you want to join again, opt-in from your user account page as you
              did the first time and we will resume sending SMS and MMS messages
              to you. You can get more information at any time by texting "HELP"
              to ####. When you send the SMS message "HELP" to us, we respond
              with instructions on how to use our service and how to
              unsubscribe.
            </Typography>
            <Typography>
              We are able to deliver messages to the following mobile phone
              carriers: Major carriers: AT&T, Verizon Wireless, Sprint,
              T-Mobile, MetroPCS, US Cellular, Alltel, Boost Mobile, Nextel, and
              Virgin Mobile. Minor carriers: Alaska Communications Systems
              (ACS), Appalachian Wireless (EKN), Bluegrass Cellular, Cellular
              One of East Central IL (ECIT), Cellular One of Northeast
              Pennsylvania, Cincinnati Bell Wireless, Cricket, Coral Wireless
              (Mobi PCS), COX, Cross, Element Mobile (Flat Wireless), Epic Touch
              (Elkhart Telephone), GCI, Golden State, Hawkeye (Chat Mobility),
              Hawkeye (NW Missouri), Illinois Valley Cellular, Inland Cellular,
              iWireless (Iowa Wireless), Keystone Wireless (Immix Wireless/PC
              Man), Mosaic (Consolidated or CTC Telecom), Nex-Tech Wireless,
              NTelos, Panhandle Communications, Pioneer, Plateau (Texas RSA 3
              Ltd), Revol, RINA, Simmetry (TMP Corporation), Thumb Cellular,
              Union Wireless, United Wireless, Viaero Wireless, and West Central
              (WCC or 5 Star Wireless). Carriers are not liable for delayed or
              undelivered messages.
            </Typography>
            <Typography>
              Message and data rates may apply for any messages that we send to
              you or you send to us. Message frequency will vary based on site
              configuration and alert setup. Contact your wireless provider for
              more information about your text plan or data plan. If you have
              questions about the services provided by this toll-free number,
              email us at{" "}
              <a href="mailto:support@securevizual.com">
                support@securevizual.com
              </a>
              . If you have any questions regarding privacy, read our{" "}
              <a href="/docs/privacy">privacy policy</a>.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default SmsTermsPage;
